import 'ol/ol.css';
import GPX from 'ol/format/GPX';
import Map from 'ol/Map';
import VectorSource from 'ol/source/Vector';
import View from 'ol/View';
import XYZ from 'ol/source/XYZ';
import OSM from 'ol/source/OSM';
import {Circle as CircleStyle, Fill, Stroke, Style} from 'ol/style';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import {fromLonLat} from 'ol/proj'; //necessari per fer la transformació de coordenades
import {FullScreen, defaults as defaultControls} from 'ol/control';

//exemple: https://openlayers.org/en/latest/examples/select-features.html?q=select+feature
import Select from 'ol/interaction/Select';
import {altKeyOnly, click, pointerMove} from 'ol/events/condition';

//importació de les rutes
import llista_rutes from './rutesgps.js';

var key = 'Get your own API key at https://www.maptiler.com/cloud/';
var attributions =
  '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> ' +
  '<a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>';

var colors = ['#000000','#800000','#9A6324','#808000','#469990','#000075','#ff0000','#e6194B','#f58231','#ffe119','#bfef45','#3cb44b','#42d4f4','#0000ff','#4363d8','#911eb4','#f032e6','#a9a9a9','#00ff00'];

var raster = new TileLayer({
  source: new OSM()
})

var estils = [];
for (let i=0;i<colors.length;i++) {
  var style = {
    'Point': new Style({
      image: new CircleStyle({
        fill: new Fill({
          color: 'rgba(100,100,100,.8)',
        }),
        radius: 3,
        stroke: new Stroke({
          color: colors[i],
          width: 2,
        }),
      }),
    }),
    'LineString': new Style({
      stroke: new Stroke({
        color: '#f00',
        width: 2,
      }),
    }),
    'MultiLineString': new Style({
      stroke: new Stroke({
        color: colors[i],
        width: 2,
      }),
    }),
  };
  estils.push(style);
}

var estil_gros = {
  'Point': new Style({
    image: new CircleStyle({
      fill: new Fill({
        color: 'rgba(100,100,100,.8)',
      }),
      radius: 3,
      stroke: new Stroke({
        color: colors[0],
        width: 4,
      }),
    }),
  }),
  'LineString': new Style({
    stroke: new Stroke({
      color: '#f00',
      width: 4,
    }),
  }),
  'MultiLineString': new Style({
    stroke: new Stroke({
      color: colors[0],
      width: 4,
    }),
  }),
};

var layers = [raster];
let rutes = llista_rutes();

for (let i=0;i<rutes.length;i++) {
  var vector = new VectorLayer({
    source: new VectorSource({
      url: './rutesgps/' + rutes[i],
      format: new GPX(),
    }),
    style: function (feature) {
      return estils[i%colors.length][feature.getGeometry().getType()];
    },
  });

  layers.push(vector)
}

var map = new Map({
  controls: defaultControls().extend([new FullScreen()]),
  layers: layers,
  target: document.getElementById('map'),
  view: new View({
    center: fromLonLat([1.8344,42.2815]),
    zoom: 12,
  }),
});

var displayFeatureInfo = function (pixel) {
  var features = [];
  map.forEachFeatureAtPixel(pixel, function (feature) {
    features.push(feature);
  });
  if (features.length > 0) {
    var info = [];
    var i, ii;
    for (i = 0, ii = features.length; i < ii; ++i) {
      info.push(features[i].get('name'));
    }
    document.getElementById('info').innerHTML = info.join(', ') || '(unknown)';
    document.getElementById('tooltip-content').innerHTML = info.join(', ') || '(unknown)';
    map.getTarget().style.cursor = 'pointer';
    
  } else {
    document.getElementById('info').innerHTML = '&nbsp;';
    document.getElementById('tooltip-content').innerHTML = '&nbsp;';
    map.getTarget().style.cursor = '';
  }
};

map.on('pointermove', function (evt) {
  if (evt.dragging) {
    return;
  }
  var pixel = map.getEventPixel(evt.originalEvent);
  displayFeatureInfo(pixel);
});

map.on('click', function (evt) {
  displayFeatureInfo(evt.pixel);
});

var select = null; // ref to currently selected interaction

// select interaction working on "singleclick"
var selectSingleClick = new Select();

// select interaction working on "click"
var selectClick = new Select({
  condition: click
});

// select interaction working on "pointermove"
var selectPointerMove = new Select({
  condition: pointerMove,
  style: function(feature) {
    return estil_gros[feature.getGeometry().getType()];
    }
});

var selectAltClick = new Select({
  condition: function (mapBrowserEvent) {
    return click(mapBrowserEvent) && altKeyOnly(mapBrowserEvent);
  },
});

var changeInteraction = function () {
  if (select !== null) {
    map.removeInteraction(select);
  }
  
  select = selectPointerMove;

  if (select !== null) {
    map.addInteraction(select);
    select.on('select', function (e) {
    });
  }
};

changeInteraction();